<template>
  <modal-key-container
    title="Copiar chave"
    :show-button-close="false"
    :not-close="isDisabled"
    @handleClose="() => $emit('handleClose')"
  >
    <template #content>
      <emd-text size="regular">
        {{ $t('description.begin') }}
        <b>{{ $t('description.highlight') }}</b>
        {{ $t('description.end') }}
      </emd-text>

      <copy-clipboard
        :copiable="secretKey"
        @handleCopied="handleCopied"
      />
    </template>

    <template #actions>
      <emd-button
        color="primary"
        type="outline"
        data-testid="confirm-action"
        @click="handleClick"
      >
        {{ $t(labelCopy) }}
      </emd-button>

      <emd-button
        color="primary"
        data-testid="confirm-action"
        :disabled="isDisabled"
        @click="handleClose"
      >
        {{ $t('form.button.ok') }}
      </emd-button>
    </template>
  </modal-key-container>
</template>

<script>
import { EmdButton, EmdText } from 'emerald-vue/src/components'

const BUTTON_COPY_LABELS = {
  copy: 'form.button.copy',
  copied: 'form.button.copied'
}

export default {
  name: 'ModalCopyKeyContent',

  components: {
    EmdButton,
    EmdText,

    ModalKeyContainer: () => import('./ModalKeyContainer.vue'),
    CopyClipboard: () => import('@/components/project/molecules/CopyClipboard')
  },

  props: {
    secretKey: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      labelCopy: BUTTON_COPY_LABELS.copy,
      isDisabled: true
    }
  },

  methods: {
    handleClick () {
      this.$copyText(this.secretKey).then(() => {
        this.labelCopy = BUTTON_COPY_LABELS.copied
        this.handleCopied()
        setTimeout(() => (this.labelCopy = BUTTON_COPY_LABELS.copy), 2000)
      })
    },

    handleCopied () {
      this.isDisabled = false
    },

    handleClose () {
      this.$emit('handleClose')
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "title": "Chave secreta",
      "description.begin": "Copie a chave abaixo.",
      "description.highlight": "Você não poderá consultar",
      "description.end": "esta informação novamente.",
      "form.button.copy": "Copiar chave secreta",
      "form.button.copied": "Copiado!",
      "form.button.ok": "Concluir"
    },
    "en-US": {
      "title": "Secret key",
      "description.begin": "Copy the key below.",
      "description.highlight": "you will not be able to consult",
      "description.end": "this information again.",
      "form.button.copy": "Copy secret key",
      "form.button.copied": "Copied!",
      "form.button.ok": "Conclude"
    }
  }
</i18n>
